import { Pipe, PipeTransform } from '@angular/core';
import { RespostasCriticasSolucoesDetalhesCabecalhosConferenciasDeFaturasDTO as Critica } from '../../models/conferencia-de-fatura/DetalheBeneficiarioConferenciaDeFatura';

@Pipe({
  name: 'statusDetalheConferenciaDeFatura',
})
export class StatusDetalheConferenciaDeFaturaPipe implements PipeTransform {
  transform(criticas: Critica[]): string {
    const temCritica = criticas.some(
      (critica) => critica.respostaCriticaConferenciaDeFaturaDTO?.codigo
    );
    const todasCriticasResolvidas = criticas.every(
      (critica) => critica.respostaSolucaoConferenciaDeFaturaDTO?.codigo
    );

    if (!temCritica) {
      return 'SEM CRÍTICA';
    }

    if (todasCriticasResolvidas) {
      return 'RESOLVIDO';
    }

    return 'COM CRÍTICA';
  }
}
